export const ONBOARDING_STORE_SYMBOLS = {
    OnboardingStore: Symbol.for('OnboardingStoreSymbol'),
    CompanyDetailsStore: Symbol.for('OnboardingCompanyDetailsStoreSymbol'),
    AddOutletStore: Symbol.for('AddOutletStoreSymbol'),
    BankAccountStore: Symbol.for('OnboardingBankAccountStoreSymbol'),
    OnboardingAddPersonStore: Symbol.for('OnboardingAddPersonStoreSymbol'),
    ApplicationStepsStore: Symbol.for('ApplicationStepsStoreSymbol')
}
